import React, { useState, useEffect } from 'react';
import { Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Card, CardContent } from '@mui/material';
import { UseAxios } from '../Server-Api-Instance';
// import './AgentRecentActivity.css';
import '../Shared/CommonStyle.css';

export default function AgentRecentActivity({ username }) {
    const [data, setData] = useState([]);
    const [period, setPeriod] = useState('yearly');
    const [isLoading, setIsLoading] = useState(true);
    const [hasData, setHasData] = useState(true);

    const formatDecimal = (value) => {
        return parseFloat(value).toFixed(2);
    };

    const formatCurrency = (value) => {
        const formatted = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP',
          minimumFractionDigits: 2,
        }).format(value);
        
        // Insert a space after £
        return formatted.replace('£', '£');
      };
      
    const calculateTotals = (data) => {
        const totals = {
            NoofBookings: 0,
            Duration:0,
            Noofpassengers: 0,
            SellPrice: 0,
            AgencyCommission: 0
        };

        data.forEach(item => {
            totals.NoofBookings += item.NoofBookings || 0;
            totals.Duration += item.Duration || 0;
            totals.Noofpassengers += item.Noofpassengers || 0;
            totals.SellPrice += item.SellPrice || 0;
            totals.AgencyCommission += item.AgencyCommission || 0;
        });

        return totals;
    };

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            setHasData(true);
            try {
                const axios = UseAxios(false); // Pass true to use local URL
                const response = await axios.get(`/Agent-recent-activity?username=${username}&period=${period}`);
                console.log("API Response:", response.data);
                if (response.status === 200 && response.data.length > 0) {
                    setData(response.data);
                    setHasData(true);
                } else {
                    setHasData(false);
                    setData([]);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                setHasData(false);
                setData([]);
            }
            setIsLoading(false);
        };

        fetchData();
    }, [username, period]);

    const totals = calculateTotals(data);

    return (
        <Box className="dashboard">
            <Box className="heading-box">
                RECENT DEPARTURE ACTIVITY
            </Box>
            <Box className="button-group">
                <button className={`outlined ${period === 'yearly' ? 'active' : ''}`} onClick={() => setPeriod('yearly')}> CURRENT YEAR</button>
                <button className={`outlined ${period === 'monthly' ? 'active' : ''}`} onClick={() => setPeriod('monthly')}>CURRENT MONTH</button>
                <button className={`outlined ${period === 'weekly' ? 'active' : ''}`} onClick={() => setPeriod('weekly')}>CURRENT WEEK</button>
            </Box>
            {isLoading ? (
                <div className="loading-message">
                    Loading data...
                </div>
            ) : hasData ? (
                <>
                    <Box className="card-container">
                    <Box className="card card-primary" mb={2}>
                    <><Typography 
  variant="h6" 
  component="div" 
  gutterBottom 
  sx={{ 
    // fontFamily: "Arial, sans-serif", 
    fontSize: "20px", 
    fontWeight: "800px", 
    color: "#fff" 
  }}
>
  NO. OF PASSENGERS
</Typography>

                                {/* <div class="card-title" >NO. OF PASSENGERS</div> */}
                                <div className="card-body">
                                    {totals.Noofpassengers}
                                </div>
                            </>
                            </Box>
                        <Box className="card card-primary" mb={2}>
                            <>
                            <Typography 
  variant="h6" 
  component="div" 
  gutterBottom 
  sx={{ 
    // fontFamily: "Arial, sans-serif", 
    fontSize: "20px", 
    fontWeight: "800px", 
    color: "#fff" 
  }}
>
                                    NO. OF BOOKINGS
                                </Typography>
                                {/* <div class="card-title" >NO. OF BOOKINGS</div> */}
                                <div className="card-body">
                                    {totals.NoofBookings}
                                </div>
                            </>
                        </Box>
                    </Box>
                    <TableContainer component={Paper} className="act-table-container">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Category</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 'bold' }}>Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>No. Of Room Nights</TableCell>
                                    <TableCell align="right"> {totals.Duration}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Sell Price</TableCell>
                                    <TableCell align="right"> {formatCurrency(totals.SellPrice)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Agency Commission</TableCell>
                                    <TableCell align="right">{formatCurrency(totals.AgencyCommission)}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            ) : (
                <div className="no-data-message">
                    No data available for {period}.
                </div>
            )}
        </Box>
    );
}
